<template>
  <img v-if="loading" src="/pic/ajax-loader.gif"/>
  <form id="available-note-form" v-else @submit.prevent="submit_note_form" class="form-horizontal" method="POST">
    <input type="hidden" v-if="event_id" name="event_id" v-model="event_id"/>
    <input type="hidden" name="from_page" v-model="from_page"/>
    <input type="hidden" name="contractor_ids_value" v-model="contractor_ids_value"/>
    <div class="ibox float-e-margins" >
      <div>
        <div class="row container-mobile-style">
          <div class="col-xs-12">
            <div class="form-group error display-none"></div>
            <div class="form-group input-container" v-show="!applyForAllWorkersValue">
              <label class="col-md-3 control-label">{{ workersName }}</label>
              <div class="col-md-9" >
                <select name="company_contractors[]"  class="select2 form-control required" multiple :data-title="workersName">
                  <optgroup v-for="(contractors_state,state) in contractor_option_list" :label="[state!='general'?state:'']">
                    <option v-for="(contractor,index) in contractors_state"
                            :value="index" :selected="contractor.selected"> {{ contractor.finalName }}</option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div class="form-group input-container">
              <label class="col-md-3 control-label">Title</label>
              <div class="col-md-9">
                <input type="text" name="title" v-model="calendar_note.title" class="form-control required" data-title="title">
              </div>
            </div>
            <div class="form-group" v-if="from_page=='calendar_notes'">
              <label class="col-md-3 control-label">Notes</label>
              <div class="col-md-9">
                <textarea name="description" class="form-control" v-model="calendar_note.description"></textarea>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-3 control-label col-xs-3" >
                <span>All day</span>
              </label>
              <div class="material-switch  col-md-9 col-xs-9 is-all-day-event-mobile">
                <input class="checkbox-type-settings switch-checkbox" name="isAllDayEvent" @change="allDayChanged" type="checkbox"
                       id="isAllDayEvent" ref="isAllDayEvent" v-model="calendar_note.isAllDayEvent">
                <label for="isAllDayEvent">
                </label>
              </div>
            </div>
              <div class="form-group" v-if="(loggedUser||{}).role_id!=1 && (loggedUser||{}).role_id!=11 && (loggedUser||{}).role_id!=9">
              <label class="col-md-3 control-label col-xs-3" >
                <span>Apply for all {{workersName}}</span>
              </label>
              <div class="material-switch  col-md-9 col-xs-9 is-all-day-event-mobile">
                <input class="checkbox-type-settings switch-checkbox" :checked="applyForAllWorkersValue" @change="ForAllWorkersChanged"  type="checkbox"
                       id="apply_for_all_workers" ref="apply_for_all_workers" >

                  <label for="apply_for_all_workers">
                </label>
              </div>
                  <input type="hidden" name="apply_for_all_workers" :value="applyForAllWorkersValue">

              </div>
            <div class="form-group">
              <label class="col-md-3 control-label time_zone_div">Timezone</label>
              <div class="col-md-9 time_zone_div">
                <select name="time_zone" class="select2 form-control required">
                  <option v-for="(timezone,timezoneIdentifier) in timezonesList" :value="timezoneIdentifier"
                  :selected="timezone.selected">
                    {{ timezone.value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <div class="col-md-9 col-md-offset-3 date-mobile-style" >
                <div class="row add-booking">
                  <div class="row" style="margin:0px">
                    <div class="col-md-6 input-container">
                      <div class="input-group start_date date">
                        <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                        <input name="startdate" class="form-control required" v-model="calendar_note.start_date"/>
                      </div>
                    </div>
                    <div class="col-md-6 start-time-div input-container">
                      <div class="input-group clockpicker1" data-placement="bottom" data-align="top"
                           data-autoclose="true">
                            <span class="input-group-addon"><span
                                class="glyphicon glyphicon-time"></span></span>
                        <input name="starttime" ref="starttime" class="form-control required" data-title="start time" v-model="calendar_note.start_time"/>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 to-mobile-design">To</div>
                  <div class="row" style="margin:0px">
                    <div class="col-md-6 input-container" >
                      <div class="input-group end_date date">
                        <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                        <input name="enddate" class="form-control required" v-model="calendar_note.end_date"/>
                      </div>
                    </div>
                    <div class="col-md-6 end-time-div input-container">
                      <div class="input-group clockpicker2" data-placement="bottom" data-align="top"
                           data-autoclose="true">
                              <span class="input-group-addon"><span
                                  class="glyphicon glyphicon-time"></span></span>
                        <input name="endtime" ref="endtime" class="form-control required" data-title="end time" v-model="calendar_note.end_time"/>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="form-group">
          <div class="col-md-12 align-right">
            <a type="button" @click="closePopup" class="btn btn-primary btn-settings-cancel btn-modal-width">Cancel</a>
            <button type="submit" id="button_save" class="btn btn-primary btn-modal-width">Save</button>
          </div>
        </div>

      </div>
    </div>
  </form>
</template>
<script>
import {getEventPopupData,saveCalendarEvents} from '@/modules/Calendar/api'
import {EventBus} from "@/events/event-bus";
export default {
  name: "EventPopup",
  props: ['event_id','from_page','start_date','end_date','start_time','contractor_ids_value'],
  // props: {'start_date':String,'end_date':String,'active':Number,'contractor_ids_value':String},
  data() {
    return {
      calendar_note: {},
      contractor_option_list: [],
      timezonesList: [],
      workersName: '',
      loading: true,
      loggedUser:[],
       applyForAllWorkersValue: false,
      startTime: null
    }
  },
  computed:{

  },
  methods:{
    allDayChanged(event){
      let node = $(event.currentTarget)
      if (node.is(':checked')) {
        $("#available-note-form input[name='starttime']").parents('.start-time-div').fadeOut(500)
        $("#available-note-form input[name='endtime']").parents('.end-time-div').fadeOut(500)
      } else {
        $("#available-note-form input[name='starttime']").parents('.start-time-div').fadeIn(500)
        $("#available-note-form input[name='endtime']").parents('.end-time-div').fadeIn(500)
      }
      this.calendar_note.start_time = "00:00";
      this.calendar_note.end_time = "23:59";
    },
      ForAllWorkersChanged(){
        this.applyForAllWorkersValue = !this.applyForAllWorkersValue;
      },
    revalidate(input,parent,message){
      let error = 0;
      if(input.val()===""||input.val()===null){
        removeError(parent);
        showError(parent,message);
        error++;
      }else{
        removeError(parent);
      }
      return error;
    },
    submit_note_form(){
      let vm = this;
      var error = 0;
      if (!this.applyForAllWorkersValue){
      $("#available-note-form").find("input.required, select.required").each(function(key,input){
        input = $(this);
        let title = input.data("title")
        if(input.attr("name")=="company_contractors[]"){
          title = vm.workersName
        }
        error += vm.revalidate(input,input.closest(".input-container"),"Please enter the "+title)
      });
      }else{
          $("#available-note-form").find("input.required").each(function(key,input){
              input = $(this);
              let title = input.data("title")
              error += vm.revalidate(input,input.closest(".input-container"),"Please enter the "+title)
          });
      }
      let input =  $("#available-note-form input[name='starttime']");
      var starttime = $("#available-note-form input[name='starttime']").val();
      var startdate = $("#available-note-form input[name='startdate']").val();
      var endtime = $("#available-note-form input[name='endtime']").val();
      var enddate = $("#available-note-form input[name='enddate']").val();
      if(starttime!==""&&endtime!==""){
        starttime = new Date(startdate+" " + starttime);
        starttime = starttime.getTime();
        endtime = new Date(startdate+" " + endtime);
        endtime = endtime.getTime();
        if ((startdate === enddate) && (starttime > endtime)) {
          removeError(input.closest(".col-md-6"));
          showError(input.closest(".col-md-6"),"start time is larger than end time");
          error++;
        }else{
          removeError(input.closest(".col-md-6"));
        }
      }

      input = $("#available-note-form input[name='startdate']");
      if (startdate > enddate) {
        removeError(input.closest(".col-md-6"));
        showError(input.closest(".col-md-6"),"start day is larger than end day");
        error++;
      } else {
        removeError(input.closest(".col-md-6"));
      }
      if(error==0){
        var form = document.querySelector('#available-note-form');
        $("#button_save").html('<img src="/pic/loading-4.gif">');
        saveCalendarEvents(new FormData(form)).then(response=>{

          let msg = response.data
          if (msg["success"] == 1) {
            window.location.reload();
            let events = msg['events'];
            $.each(events , function(index , value) {
              event = $(this)[0];
              if(event['method']=="edit"){
                if(calendar!=null){
                  var eventToDelete = calendar.getEventById( event["id"] );
                  if (eventToDelete != null)
                    eventToDelete.remove();
                }
              }
              if(calendar!=null){
                //if show unavailable in calendar or it on day view
                var contractor_id = event['contractors'] != undefined  && event['contractors'].length > 0 ? event['contractors'][0]['contractor_id'] : '';
                var title = event['contractors'] != undefined  && event['contractors'].length > 0? event['contractors'][0]['contractor_profile'] : '';
                if(event['inCalendar']
                     ||$(".fc-resourceTimeGridDay-button").hasClass("active")
                ) {
                  calendar.addEvent(event);
                }
                if(allEvents!=null){
                  allEvents.push(event);
                }
                let existResource = calendar.getResourceById(contractor_id);
                if(existResource!=null){
                  calendar.addResource( {
                    id :  contractor_id,
                    title:  title,
                    extendedProps :  title
                  } );
                }
                $(".fc-col-header-cell-cushion").remove();//remove this div that has html fieldworker title in calendar day view
              }
            });

            $(".cl-alert-success").html(msg["message"]);
            $(".cl-alert-success").slideDown();

            setTimeout(function(){
              $(".cl-alert-success").fadeOut("slow", function(){
              });
            }, 9000);
            $("#event-modal").modal("hide")
          } else {
            $("#content_modal_popup").html(msg);
          }
          $('#button_save').html('Save');

        });
      }

    },
    closePopup(){
      $("#event-modal").modal("hide")
    },
    eventPopupData(){
      let vm = this
      getEventPopupData(this.event_id,this.from_page,this.start_date,this.end_date,this.start_time,this.contractor_ids_value).then(response=>{

        let data = response.data
        this.calendar_note = data.calendar_note;
        this.contractor_option_list = data.contractor_option_list;
        this.workersName = data.workersName;
        if (data.loggedUser){

          this.loggedUser = data.loggedUser;
          if ((data.loggedUser||{}).role_id!=1 && (data.loggedUser||{}).role_id!=11 && (data.loggedUser||{}).role_id!=9){
            this.applyForAllWorkersValue = data.calendar_note.apply_for_all_workers==1;
          }
        }
        this.timezonesList = data.timezonesList;
        this.loading = false;

        vm.$nextTick(()=>{
          $(".select2").select2({
            'placeholder': 'Select '+this.workersName
          });
          if(this.calendar_note.isAllDayEvent){
            $("#available-note-form input[name='starttime']").parents('.start-time-div').fadeOut(500)
            $("#available-note-form input[name='endtime']").parents('.end-time-div').fadeOut(500)
            // $(this.$refs["isAllDayEvent"]).trigger("change")
          }
          let input= $('#available-note-form .date').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            calendarWeeks: true,
            autoclose: true,
            format: 'yyyy-mm-dd'
          })
          $(".start_date").on('changeDate', (event) => {
            this.calendar_note.start_date=event.format()
          });
          $(".end_date").on('changeDate', (event) => {
            this.calendar_note.end_date=event.format()
          });
          $('#available-note-form .clockpicker1').clockpicker({
            autoclose: true,
            afterDone: function() {
              vm.calendar_note.start_time = $(vm.$refs['starttime']).val()
              vm.revalidate( $(vm.$refs['starttime']),$(vm.$refs['starttime']).closest(".col-md-6"),"Please enter start time");
            }
          });
          $('#available-note-form .clockpicker2').clockpicker({
            autoclose: true,
            afterDone: function() {
              vm.calendar_note.end_time = $(vm.$refs['endtime']).val()
              vm.revalidate($(vm.$refs['endtime']),$(vm.$refs['endtime']).closest(".col-md-6"),"Please enter end time");
            }
          });
        })

      });
    }
  },
  mounted(){
    let vm = this;

    EventBus.$on('onPopupOpened', (startTime) => {
      console.log("Callled")
      console.log(startTime)
      this.$set(this.calendar_note,'start_time',startTime)
      console.log(this.calendar_note)
      this.$forceUpdate()
    })
    this.eventPopupData()
    // fetch("calendar/calendar-notes").then(data=>{
    //   return data.json()
    // }).then((data)=>{
    // });


  }
}
</script>